// Rich-text helpers shared by the task view and the admin trash view.

// One-line plain-text preview of rich-text HTML: block breaks become spaces, entities (&nbsp; etc.) are decoded.
export function htmlPreview(value) {
  const html = String(value || "").replace(/<(br|\/p|\/div|\/li)[^>]*>/gi, " ");
  const text = new DOMParser().parseFromString(html, "text/html").body.textContent || "";
  return text.replace(/\s+/g, " ").trim();
}

export function sanitizeBasicHtml(value = "") {
  const doc = new DOMParser().parseFromString(
    `<div>${value}</div>`,
    "text/html",
  );
  const allowed = new Set([
    "DIV",
    "P",
    "BR",
    "B",
    "STRONG",
    "I",
    "EM",
    "U",
    "UL",
    "OL",
    "LI",
  ]);
  [...doc.body.querySelectorAll("*")].forEach((node) => {
    if (!allowed.has(node.tagName)) node.replaceWith(...node.childNodes);
    else
      [...node.attributes].forEach((attribute) =>
        node.removeAttribute(attribute.name),
      );
  });
  return doc.body.firstElementChild?.innerHTML || "";
}
